export const AVAILABLE_LOCALES = [
    "fr-FR",
    "en-US",
    "es-ES",
    "it-IT",
    // "de-DE",
];
export const DEFAULT_LANGUAGE_KEY = "i18nDefaultLanguage";

export const FIRST_DAY_OF_WEEK_PER_LOCALE: Record<string, number> = {
    "fr-FR": 1,
    "en-US": 1,
    "es-ES": 1,
    "it-IT": 1,
    // "de-DE": 1,
};

export const findFirstDayOfWeek = (locale: string): number => {
    return FIRST_DAY_OF_WEEK_PER_LOCALE[locale] ?? 0;
};
